import axios from 'axios';
import Config from '@/Config';

axios.defaults.withCredentials = true;

const host = `${Config.host}/Alimentos/`

function DarAlimentos(){
    const url = `${host}DarAlimentos.php`
    return axios.get(url).then(response =>
        response.data
    );
}
export {
    DarAlimentos
}
